import React from 'react';
import { PRIVATE_MARKDOWN_TABLE_SECTION } from './section';
import { getTheme, IStyle, ITheme, mergeStyles } from '@fluentui/react';
import { useCollectionKeys } from '../../../../framework/hooks/collection-keys';
import { ITableComponentModel, TableColumnAlignment } from '../../parser/table';
import { TextAlign } from './text-align';

const getStyleClass = (theme: ITheme, colCount: number) => {
  const colWidth = 100 / colCount;

  const style: IStyle = {
    fontSize: '1em',
    borderCollapse: 'collapse',
    maxWidth: '100%',
    marginBottom: '1em',

    '& thead': {
      borderTop: `4px solid ${theme.palette.neutralTertiary}`,
      borderBottom: `2px solid ${theme.palette.neutralTertiary}`,
      backgroundColor: theme.palette.neutralLighter,
    },

    '& tfoot': {
      borderTop: `2px solid ${theme.palette.neutralTertiary}`,
      backgroundColor: theme.palette.neutralLighter,
    },

    '& th': {
      border: `1px solid ${theme.palette.neutralTertiary}`,
      padding: '0.6em .9em',
      verticalAlign: 'top',
    },

    '& td': {
      border: `1px solid ${theme.palette.neutralTertiary}`,
      padding: '0.6em .9em',
      verticalAlign: 'top',
    },

    '& td > img': {
      border: 0,
      margin: 0,
      padding: 0,
      maxWidth: `calc(((-80px + -8.8em) / ${colCount}) + ${colWidth.toFixed(2)}vw)`,
    },

    '& th > img': {
      border: 0,
      margin: 0,
      padding: 0,
      maxWidth: `calc(((-80px + -8.8em) / ${colCount}) + ${colWidth.toFixed(2)}vw)`,
    },
  };

  return mergeStyles([style]);
}

export const MarkdownTable: React.FunctionComponent<ITableComponentModel> = (props) => {
  const { columnAlignments } = props;
  const theme = getTheme();
  const colWidth = `${(100 / columnAlignments.length).toFixed(2)}%`;
  const styleClass = getStyleClass(theme, columnAlignments.length);
  const colKeys = useCollectionKeys(columnAlignments);

  return (
    <table className={styleClass}>
      <colgroup>
        {props.columnAlignments.map((a, index) => <col key={colKeys[index]} style={{ width: colWidth, textAlign: a !== TableColumnAlignment.Default ? TableColumnAlignment[a].toLowerCase() as TextAlign : undefined }}/>)}
      </colgroup>
      {props.header.length > 0 && <PRIVATE_MARKDOWN_TABLE_SECTION sectionElement='thead' rows={props.header} columnAlignments={props.columnAlignments} />}
      {props.body.length > 0 && <PRIVATE_MARKDOWN_TABLE_SECTION sectionElement='tbody' rows={props.body} columnAlignments={props.columnAlignments} />}
      {props.footer.length > 0 && <PRIVATE_MARKDOWN_TABLE_SECTION sectionElement='tfoot' rows={props.footer} columnAlignments={props.columnAlignments} />}
    </table>
  );
};
